module.exports = __webpack_public_path__ + "img/icn-hot-checked.49171261.png";